import { getDetectedTimezone } from "../utils/timezone";

export const sanitizeInheritedValue = (value: any) => {
  if (typeof value === 'string' && value.startsWith('[value-')) return null;
  return value;
};

export const areArraysEqual = (a: any, b: any) => {
  if (!Array.isArray(a) || !Array.isArray(b)) return a === b;
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort().map(String);
  const sortedB = [...b].sort().map(String);
  return sortedA.every((val, index) => val === sortedB[index]);
};

export const getTimezoneValue = (tz: string | undefined | null): string => {
  if (!tz || tz.trim() === "") return getDetectedTimezone();
  return tz;
};

export const isDirectOverride = (
  value: any,
  parentValue: any,
  settingKey?: string,
) => {
  const v = sanitizeInheritedValue(value);
  const p = sanitizeInheritedValue(parentValue);

  if (settingKey === 'ppe_types') {
    return (
      v !== null &&
      v !== undefined &&
      !areArraysEqual(v, p)
    );
  }

  return (
    v !== null &&
    v !== undefined &&
    v !== p
  );
};